import {useEffect} from "react";

export default function Modal(props) {
    useEffect(() => {
        modalToggler(props.show);
    }, [props.show]);

    function modalToggler(show) {
        // let modalEl = document.getElementById('modal');
        // if (show) {
        //     if (! modalEl.classList.contains('modal-open')) modalEl.classList.add('modal-open');
        // } else {
        //     if (modalEl.classList.contains('modal-open')) modalEl.classList.remove('modal-open');
        // }
    }

    // const yesHandler = props.yesHandler ? props.yesHandler : ()=>{console.log('yes')};

    return (
        <div id='modal' className="modal-custom" style={{ display: props.show ? '' : 'none' }}>
            <div className='modal-wrapper'>
                <div className='modal-dialog-custom'>
                    <div className='modal-content-custom'>
                        <div className='modal-header-custom'>
                            <h3 className='modal-title-custom'>{props.header}</h3>
                            <a className='close' onClick={props.closeHandler}>x</a>
                        </div>
                        <div className='modal-body-custom'>
                            {props.children}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}